import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

import { Button, Form, Container } from "semantic-ui-react";

import { useQuery } from "react-query";
import { getAllMutu, useAddUser } from "../../Api/api";

import { useDispatch } from "react-redux";
import { previous_search } from "../../../features/patientelle/patientelleSlice";
import { toast } from "react-toastify";
import SpeedDialComponent from "../../SpeedDial/SpeedDialComponent"
import useGetDoctors from "../../../CustomHooks/useGetDoctors";
import useGetDoctorsSemanticUI from "../../../CustomHooks/useGetDoctorsSemanticUI"


function CreatePatientelle() {
  const data = useGetDoctors()
  const Doctors = useGetDoctorsSemanticUI()

  const dispatch = useDispatch();
  const { register, handleSubmit, reset } = useForm();

  const mutuelles = useQuery("mutuelles", () => getAllMutu());

  const {
    mutate,
    isLoading: Loading_ADD_User,
    data: DATA_Response_ADD_User,
    isError: isError_Response_ADD_User,
  } = useAddUser();

  const resetForm = () => {
    if (DATA_Response_ADD_User) {
      // dispatch(
      //   post_success_grab_ID(
      //     DATA_Response_ADD_User
      //       ? DATA_Response_ADD_User?.data[0]?.insertId
      //       : ""
      //   )
      // );
      sessionStorage.setItem(
        "ID_Session",
        DATA_Response_ADD_User?.data[0]?.insertId
      );
      reset();
    }
  };

  let loadingComponent;

  if (Loading_ADD_User) {
    loadingComponent = <h1>Loading.....</h1>;
  }
  if (isError_Response_ADD_User) {
    toast.error("error", {
      position: toast.POSITION.TOP_CENTER,
    });
  }

  useEffect(() => {
    resetForm();
    // eslint-disable-next-line
  }, [DATA_Response_ADD_User]);

  const onSubmit = (data) => {

    if (data.fk_id_medecin === "") {
      data.fk_id_medecin = Doctors?.Doctors_list[0]?.value
    }

    mutate(data);
    dispatch(previous_search(data));
  };

  let mutu_list = "";

  if (mutuelles?.data) {
    mutu_list = mutuelles?.data.map((item, index) => (
      <option className="item" key={index} value={item.id_liste_mutuelle}>
        {item.nom_mutuelle}
      </option>
    ));
  }

  // ================READ FILE LOGIC=======================
  // let fileReader = new FileReader();
  // fileReader.onload = function (event) {
  // 	alert(fileReader.result);
  // };
  // let q = (event) => {
  // 	fileReader.readAsText(event.target.files[0]);
  // };
  // ================READ FILE LOGIC=======================


  // let galaxyFold = <>
  // <Grid.Row>

  // </Grid.Row>
  // </>


  return (
    <>
      <div className="heightFix">
        <br />
        <br />
        <br />
        <Container>
          <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <Form.Group widths="equal" className="MyForm">
              <div className="required field">
                <label>Civilite</label>
                <select
                  name="fk_id_civilite"
                  // role="listbox"
                  aria-expanded="false"
                  className="ui selection dropdown"
                  {...register("fk_id_civilite")}
                >
                  <option className="item" value={0}>
                    choisissez une option
                  </option>
                  <option className="item" value="1">
                    Madame
                  </option>
                  <option className="item" value="2">
                    Monsieur
                  </option>
                  <option className="item" value="3">
                    Mademoiselle
                  </option>
                  <option className="item" value="4">
                    Enf.
                  </option>
                  <option className="item" value="5">
                    Bébé
                  </option>
                </select>
              </div>

              <div className="required field">
                <label>Nom</label>
                <div className="ui input">
                  <input
                    name="nom"
                    maxLength={40}
                    required
                    type="text"
                    {...register("nom")}
                  />
                </div>
              </div>

              <div className="required field">
                <label>Prenom</label>
                <div className="ui input">
                  <input
                    name="prenom"
                    maxLength={40}
                    required
                    type="text"
                    {...register("prenom")}
                  />
                </div>
              </div>
            </Form.Group>
            <Form.Group widths="equal" className="MyForm">
              <div className="required field">
                <label>Date de naissance</label>
                <div className="ui input">
                  <input
                    type="date"
                    name="date_naissance"
                    required
                    min="1900-01-01"
                    max="3018-12-31"
                    {...register("date_naissance")}
                  ></input>
                </div>
              </div>
              <div className="required field">
                <label>Mutuelle</label>
                <select
                  name="fk_id_liste_mutuelle"
                  // role="listbox"
                  aria-expanded="false"
                  className="ui selection dropdown"
                  required
                  {...register("fk_id_liste_mutuelle")}
                >
                  <option className="item" value={0}>
                    choisissez une option
                  </option>
                  {mutu_list}
                </select>
              </div>
              <div className="required field">
                <label>Medecin</label>
                <select
                  name="fk_id_medecin"
                  // role="listbox"
                  aria-expanded="false"
                  className="ui selection dropdown"
                  required
                  {...register("fk_id_medecin")}
                >
                  {data?.Doctors_list}
                </select>
              </div>




            </Form.Group>
            <Form.Group widths="equal" className="MyForm">
              <div className=" field">
                <label>Tel</label>
                <div className="ui input">
                  <input
                    name="tel"
                    maxLength={10}
                    type="text"
                    {...register("tel")}
                  />
                </div>
              </div>

              <div className=" field">
                <label>Tel2</label>
                <div className="ui input">
                  <input
                    name="tel2"
                    maxLength={10}
                    type="text"
                    {...register("tel2")}
                  />
                </div>
              </div>

              <div className=" field">
                <label>Tel3</label>
                <div className="ui input">
                  <input
                    name="tel3"
                    maxLength={10}
                    type="text"
                    {...register("tel3")}
                  />
                </div>
              </div>

            </Form.Group>
            <Form.Group>

              <div className="field">
                <label>CIN</label>
                <div className="ui input">
                  <input
                    name="cin"
                    maxLength={10}
                    type="text"
                    {...register("cin")}
                  />
                </div>
              </div>

              <div className=" field">
                <label>Commentaire</label>
                <div className="ui form">
                  <textarea
                    placeholder="Commentaire"
                    name="commentaire_sur_patient"
                    maxLength={1000}
                    type="text"
                    {...register("commentaire_sur_patient")}
                    rows="3"
                  />
                </div>
              </div>
            </Form.Group>


            <Button className="someMarginTopQuerry" floated="right" positive>
              Enregistrer
            </Button>


          </Form>
          {loadingComponent}
        </Container>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>

        <SpeedDialComponent />
      </div>
    </>
  );
}

export default CreatePatientelle;
